<template>
  <div id="sysStyleSetting">
    <el-form
      ref="styleForm"
      :rules="rules"
      :model="styleForm"
      v-loading="formLoading"
      label-width="120px"
    >
      <el-form-item label="系统名" prop="sysName">
        <el-input
          v-model="styleForm.sysName"
          placeholder="请输入系统名称1-30个字"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="分享标题" prop="shareTitle">
        <el-input
          v-model="styleForm.shareTitle"
          placeholder="请输入分享标题1-30个字"
          maxlength="30"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="分享ICON">
        <el-upload
          ref="upload"
          action="/api/sysConfig/upload"
          list-type="picture-card"
          :limit="1"
          :on-success="uploadShareIconSuccess"
          :on-remove="removeShareIcon"
          :file-list="shoreIconImageFile"
        >
          <i class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
        <p style="color: red">
          *图片格式：favicon大小建议50*50，用于浏览器ICON缩略图
        </p>
      </el-form-item>
      <el-form-item label="系统LOGO">
        <el-upload
          ref="upload"
          action="/api/sysConfig/upload"
          list-type="picture-card"
          :limit="1"
          :on-success="uploadSysLogoSuccess"
          :on-remove="removeSysLogo"
          :file-list="sysLogoImageFile"
        >
          <i class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
        <p style="color: red">
          *图片格式：favicon、PNG、Jpg，大小建议106*26 像素，用于系统登录页LOGO
        </p>
      </el-form-item>
      <el-form-item label="系统首页LOGO">
        <el-upload
          ref="upload"
          action="/api/sysConfig/upload"
          list-type="picture-card"
          :limit="1"
          :on-success="uploadHomepageLogoSuccess"
          :on-remove="removeHomepageLogo"
          :file-list="homepageLogoImageFile"
        >
          <i class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
        <p style="color: red">
          *图片格式：favicon、PNG、Jpg，大小建议150*60像素，用于系统登录后的左上LOGO
        </p>
      </el-form-item>
      <el-form-item label="备案号" prop="recordNo">
        <el-input
          v-model="styleForm.recordNo"
          placeholder="请输入备案号"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="备案链接" prop="recordLink">
        <el-input
          v-model="styleForm.recordLink"
          placeholder="请输入备案链接"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="版权说明(英文)" prop="copyrightEn">
        <el-input
          v-model="styleForm.copyrightEn"
          placeholder="请输入英文版权说明"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="版权说明(中文)" prop="copyrightCn">
        <el-input
          v-model="styleForm.copyrightCn"
          placeholder="请输入中文版权说明"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="editSysConfigSure">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from "../utils/utils";
import httpRequest from "../utils/httpRequest";
export default {
  name: "sys-style-setting",
  data() {
    return {
      styleForm: {
        sysName: "",
        shareTitle: "",
        shareIcon: "",
        sysLogo: "",
        homepageLogo: "",
      },
      formLoading: false,
      shoreIconImageUrl: "",
      shoreIconImageFile: [],
      sysLogoImageUrl: "",
      sysLogoImageFile: [],
      homepageLogoImageUrl: "",
      homepageLogoImageFile: [],
      rules: {
        shareTitle: [
          {
            required: true,
            message: "请填写分享标题",
            trigger: "blur",
          },
        ],
        sysName: [
          {
            required: true,
            message: "请输入系统名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getSysConfig();
  },
  methods: {
    uploadShareIconSuccess(response, file, fileList) {
      let shoreIconImageUrl = [];
      fileList.forEach((item) => {
        shoreIconImageUrl.push(item.response);
      });
      this.shoreIconImageUrl = shoreIconImageUrl.join(";");
    },
    uploadSysLogoSuccess(response, file, fileList) {
      let sysLogoImageUrl = [];
      fileList.forEach((item) => {
        sysLogoImageUrl.push(item.response);
      });
      this.sysLogoImageUrl = sysLogoImageUrl.join(";");
    },
    uploadHomepageLogoSuccess(response, file, fileList) {
      let homepageLogoImageUrl = [];
      fileList.forEach((item) => {
        homepageLogoImageUrl.push(item.response);
      });
      this.homepageLogoImageUrl = homepageLogoImageUrl.join(";");
    },
    removeShareIcon(file, fileList) {
      this.shoreIconImageUrl = "";
      // 删除原有图片
      // utils.axiosMethods({
      //   method: "POST",
      //   url: "/upload/sysConfig/deletefile",
      //   params: {
      //     url: file.response ? file.response : file.url
      //   }
      // });
    },
    removeSysLogo(file, fileList) {
      this.sysLogoImageUrl = "";
      // 删除原有图片
      // utils.axiosMethods({
      //   method: "POST",
      //   url: "/upload/sysConfig/deletefile",
      //   params: {
      //     url: file.response ? file.response : file.url
      //   }
      // });
    },
    removeHomepageLogo(file, fileList) {
      this.homepageLogoImageUrl = "";
      // 删除原有图片
      // utils.axiosMethods({
      //   method: "POST",
      //   url: "/upload/sysConfig/deletefile",
      //   params: {
      //     url: file.response ? file.response : file.url
      //   }
      // });
    },
    getSysConfig() {
      this.formLoading = true;
      httpRequest
        .get("/api/sysConfig/getSysConfigByType?type=2")
        .then((res) => {
          this.styleForm = res.data.obj;
          this.shoreIconImageFile = this.styleForm.shareIcon
            ? [
                {
                  url: this.styleForm.shareIcon,
                },
              ]
            : [];
          this.shoreIconImageUrl = this.styleForm.shareIcon;
          this.sysLogoImageFile = this.styleForm.sysLogo
            ? [
                {
                  url: this.styleForm.sysLogo,
                },
              ]
            : [];
          this.sysLogoImageUrl = this.styleForm.sysLogo;
          this.homepageLogoImageFile = this.styleForm.homepageLogo
            ? [
                {
                  url: this.styleForm.homepageLogo,
                },
              ]
            : [];
          this.homepageLogoImageUrl = this.styleForm.homepageLogo;
          this.formLoading = false;
        })
        .catch((e) => {
          this.formLoading = false;
        });
    },
    editSysConfigSure() {
      //验证表单
      this.$refs["styleForm"].validate((valid) => {
        if (valid) {
          let formData = {
            id: this.styleForm.id,
            sysName: this.styleForm.sysName,
            shareIcon: this.shoreIconImageUrl,
            sysLogo: this.sysLogoImageUrl,
            homepageLogo: this.homepageLogoImageUrl,
            shareTitle: this.styleForm.shareTitle,
            recordLink:this.styleForm.recordLink,
            recordNo:this.styleForm.recordNo,
            copyrightCn:this.styleForm.copyrightCn,
            copyrightEn:this.styleForm.copyrightEn,
          };
          this.formLoading = true;
          httpRequest
            .post("/api/sysConfig/update", formData)
            .then((res) => {
              this.formLoading = false;
              this.$message.success("修改成功");
            })
            .catch((e) => {
              this.formLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less">
#sysStyleSetting {
  .el-upload--picture-card {
    width: 60px;
    height: 60px;
    line-height: 60px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 60px;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sysStyleSetting.vue